import { type DepositAccount } from '@fruitful/types';
import * as React from 'react';
import { Platform } from 'react-native';
import {
    ArrowRightIcon,
    FruitfulCustomIcon,
    Icon,
    InstitutionLogo,
    View,
    XStack,
} from 'smoothie';

interface TransactionIconsProps {
    fromAccount?: DepositAccount;
    toAccount?: DepositAccount;
    iconBorderRadius?: number;
}

export const TransactionIcons = ({
    fromAccount,
    toAccount,
    iconBorderRadius = 20,
}: TransactionIconsProps) => {
    let fromLogo: React.JSX.Element;
    if (fromAccount === undefined) {
        fromLogo = <InstitutionLogo size="lg" />;
    } else if (fromAccount.isExternal) {
        fromLogo = <InstitutionLogo size="lg" logo={fromAccount.logo} />;
    } else {
        fromLogo = (
            <FruitfulCustomIcon
                icon={fromAccount.icon}
                color={fromAccount.color}
                size="lg"
            />
        );
    }

    let toLogo: React.JSX.Element;
    if (toAccount === undefined) {
        toLogo = <InstitutionLogo size="lg" />;
    } else if (toAccount.isExternal) {
        toLogo = <InstitutionLogo size="lg" logo={toAccount.logo} />;
    } else {
        toLogo = (
            <FruitfulCustomIcon
                icon={toAccount.icon}
                color={toAccount.color}
                size="lg"
            />
        );
    }

    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.05,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <XStack style={{ ...shadowStyle }}>
            <View marginRight={-12} borderRadius={iconBorderRadius}>
                {fromLogo}
            </View>
            <View
                backgroundColor="$white"
                padding={8}
                borderRadius={100}
                borderWidth={1}
                borderColor="$gray100"
                alignSelf="center"
                zIndex={1}
            >
                <Icon icon={ArrowRightIcon} size={16} />
            </View>
            <View marginLeft={-12} borderRadius={iconBorderRadius}>
                {toLogo}
            </View>
        </XStack>
    );
};
